export function SaveUserDataToLocalStorage(userData, userToken) {
  localStorage.setItem("user-info", userData);
  localStorage.setItem("user-token", userToken);
  localStorage.setItem("is-logged", JSON.stringify(true));
  // localStorage.setItem("isRtl", JSON.stringify(true));
}
